import React, {useEffect, useState} from "react";
import {IonButton} from "@ionic/react";
import {InboundAuctionsData} from "./InboundAuctionData";
import {AdminProps, InboundAdminProps} from "../Outbound/AdminProps";

import {sendInboundGetRequest} from "../hooks/sendInboundGetRequestHook";
import {IOrder} from "../Outbound/IOrder";

export const InboundAdminGrid: React.FC<InboundAdminProps> = ({show, editData, user}) => {
    const [data, setData] = useState<IOrder[]>([]);

    let email = user.username
    useEffect(() => {
        if (email) {
            sendInboundGetRequest(user)?.then(data => setData(data));
        }
    }, [email]);
    const refresh = async () => {
        const data = await sendInboundGetRequest(user)
        setData(data);
    };
    return <><IonButton onClick={() => refresh()}>Refresh</IonButton>
        {show && <div>
            <InboundAuctionsData data={data} editItem={(item) => editData(item)} refreshList={refresh} user={user}/>
        </div>
        }</>;
};
